"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeMappingMenuService = void 0;
class SizeMappingMenuService {
    constructor() {
        this.modals = [];
    }
    add(modal) {
        return this.modals.push(modal);
    }
    remove(id) {
        this.modals = this.modals.filter(m => { return m.id != id; });
    }
    open(id, adUnit, integration) {
        for (let m in this.modals) {
            if (this.modals[m].id == id) {
                this.modals[m].adUnit = adUnit;
                this.modals[m].integration = integration;
                this.modals[m].open();
                break;
            }
        }
    }
    close(id) {
        for (let m in this.modals) {
            if (this.modals[m].id == id) {
                this.modals[m].close();
                break;
            }
        }
    }
}
exports.SizeMappingMenuService = SizeMappingMenuService;
//# sourceMappingURL=size-mapping-menu.service.js.map